export const keys = {
  country: {
    detect: ["country", "detect"] as const,
  },
};